import { Component, OnInit, EventEmitter, Output, Input  } from '@angular/core';
import { DashboardService } from '../dashboard/dashboard.service';
import { environment } from '../../environments/environment';
import {loadStripe} from '@stripe/stripe-js';
import { Router } from '@angular/router';
import * as $ from 'jquery';

declare let paypal: any;
@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {
  @Input() address;
  @Input() type;
  @Output() confirmed = new EventEmitter<any>();
  error = false;
  cancel = false;
  success = false;
  loading = false;
  code;
  codeError;
  showCode = false;
  constructor(private dashboardService : DashboardService, private router: Router) { }
  
  async goToStripe(){
    let price;

    switch(this.address.country){
      case "France":
        price = environment.stripePriceFr;
        break;
      case "United States":
        price = environment.stripePriceUs;
        break;
      case "Canada":
        price = environment.stripePriceCa;
        break;
    }

    
    const stripe = await loadStripe(environment.stripe);

    
    const {error} = await stripe.redirectToCheckout({
      lineItems: [
        // Replace with the ID of your price
        {price: price, quantity: 1}
      ],
      customerEmail: localStorage.getItem("maplerace_email"),
      clientReferenceId: localStorage.getItem("maplerace_email"),
      mode: 'payment',
      successUrl: "https://" + window.location.hostname + '/#/premium?info=1',
      cancelUrl: "https://" + window.location.hostname + '/#/premium'
    })
  }

  ngOnInit(): void {

  }


  addPayment(orderId, 
              status,
              payerId?, 
              createTime?,
              payerCountryCode?,
              payerEmailAddress?,
              name?,
              surname?,
              amountValue?,
              currencyCode?){
    
                this.dashboardService.addPayment(orderId, 
                                                  status,
                                                  "VirtualRacesFrance Paypal", 
                                                  payerId, 
                                                  createTime, 
                                                  payerCountryCode,
                                                  payerEmailAddress, 
                                                  name, 
                                                  surname, 
                                                  amountValue, 
                                                  currencyCode)
                      .subscribe(res => {},
                      err => {
                          this.error = true
                      },
                      () => { });
  }

  restart(){
    window.location.reload();
  }

  useCode(){
    this.dashboardService.useCode(this.code)
      .subscribe(res => {
        this.router.navigateByUrl('/premium?type=gift&info=' + res['type']);
      },
      (err) => {
        if(err.status == 409){
          this.codeError = err.error;
        }else{
          this.codeError = "An error occurred";
        }
      },
      ()=>{
        
      });
  }

}